import { useRouteError } from "react-router-dom";
import { ContentHeader } from "../../../components/structure/ContentHeader";
import { Button } from "../../../components/buttons/Button";
import { ReactComponent as Exclamation } from "../../../../resources/icons/circle-exclamation.svg";
import React from "react";
import { ApplicationScreen } from "../../../components/top-level/screen/ApplicationScreen";

interface ErrorPageScreenProps {
    error?: any;
}

export function ErrorPageScreen({ error }: ErrorPageScreenProps) {
    let error2 = useRouteError();
    if (error2) {
        error = error2;
    }
    return <ApplicationScreen withUser={false}>
        <div className={"flex-1"}>
            <div className={"w-full min-h-content p-64"}>
                <div className={"flex flex-col items-center mx-auto mt-[120px]"}>
                    <Exclamation className={"h-[200px] w-[200px] mb-60"} />
                    <ContentHeader className={"!text-l mb-16"}>
                        Der er opstået en ukendt fejl!
                    </ContentHeader>
                    <p
                        className={
                            "text-xn break-normal max-w-[650px] mb-32 text-center"
                        }
                    >
                        Hvis denne fejl opstart gentagne gange, skal du
                        <br />kontakte applikationsupporten ved Færdselsstyrelsen.
                        <br />Ved henvendelse skal du medtage nedenstående fejlbesked.
                    </p>
                    <Button onClick={() => {
                        window.location.href = window.location.origin;
                    }}>Gå til forside</Button>
                    {/* @ts-ignore*/}
                    {error.stack && <div
                        className={"mt-24 p-16 bg-secondary-gray-light text-sx h-[250px] overflow-y-scroll max-w-[650px]"}>
                        {/* @ts-ignore*/}
                        {error.stack}
                    </div>}
                </div>
            </div>
        </div>
    </ApplicationScreen>;
}

export function PageUnknownErrorErrorScreen() {
    return <div className={"flex-1"}>
        <div className={"w-full min-h-content p-64"}>
            <div className={"flex flex-col items-center mx-auto mt-[120px]"}>
                <Exclamation className={"h-[200px] w-[200px] mb-60"} />
                <ContentHeader className={"!text-l mb-16"}>
                    Der er opstået en ukendt fejl!
                </ContentHeader>
                <p
                    className={
                        "text-xn break-normal max-w-[650px] mb-32 text-center"
                    }
                >
                    Hvis denne fejl opstart gentagne gange, skal du
                    <br />kontakte applikationsupporten ved Færdselsstyrelsen.

                </p>
                <Button onClick={() => {
                    window.location.href = window.location.origin;
                }}>Gå til forside</Button>
            </div>
        </div>
    </div>;
}

export function PageNotFoundScreen() {
    return <div className={"flex-1"}>
        <div className={"w-full min-h-content p-64"}>
            <div className={"flex flex-col items-center mx-auto mt-[120px]"}>
                <Exclamation className={"h-[200px] w-[200px] mb-60"} />
                <ContentHeader className={"!text-l mb-16"}>
                    Siden kunne ikke findes
                </ContentHeader>
                <p
                    className={
                        "text-xn break-normal max-w-[650px] mb-32 text-center"
                    }
                >
                    Den ressource, du forsøger at få adgang til, findes ikke
                    <br />
                    eller kan være blevet slettet
                </p>
                <Button onClick={() => {
                    window.location.href = window.location.origin;
                }}>Gå til forside</Button>
            </div>
        </div>
    </div>;
}

export function PageForbiddenScreen() {
    return <div className={"flex-1"}>
        <div className={"w-full min-h-content p-64"}>
            <div className={"flex flex-col items-center mx-auto mt-[120px]"}>
                <Exclamation className={"h-[200px] w-[200px] mb-60"} />
                <ContentHeader className={"!text-l mb-16"}>
                    Du har ikke adgang til denne side
                </ContentHeader>
                <p
                    className={
                        "text-xn break-normal max-w-[650px] mb-32 text-center"
                    }
                >
                    Den ressource, du forsøger at læse, har du ikke adgang til
                </p>
                <Button onClick={() => {
                    window.location.href = window.location.origin;
                }}>Gå til forside</Button>
            </div>
        </div>
    </div>;
}
